// extracted by mini-css-extract-plugin
export var csatScore = "_jq-5";
export var header = "_jq-1";
export var panelWrapper = "_jq-2";
export var postPreview = "_jq-3";
export var rightContent = "_jq-0";
export var wrappingText = "_jq-4";